export default defineNuxtPlugin((nuxtApp) => {
  const bugsnag = nuxtApp.$bugsnag
  if (!bugsnag) return

  bugsnag.addOnError((event) => {
    // Ignore errors from browser user scripts (Tampermonkey, Greasemonkey, etc.)
    // These appear as `user-script:` in stack frame file paths and are not our code.
    const hasUserScriptFrame = event.errors.some((error) =>
      error.stacktrace.some((frame) => frame.file?.startsWith("user-script:")),
    )
    if (hasUserScriptFrame) return false
  })
})
